import * as yup from "yup";

export const updateAccountExtendValidator = {
  confirm_password: yup
    .string()
    .test(
      "confirmPassword",
      "Passwords must match",
      (value, context) => value === context.parent.password,
    ),
};
